module.exports = __webpack_public_path__ + "img/img (38).ce8f8c1c.jpg";